/**
 * Whale (세력) cycle configuration.
 * Hidden state machine on meme-tier coins:
 * dormant -> accumulating -> pumping -> dumping -> dormant.
 * Never surfaced in UI directly - only through candle patterns
 * (and the short ad-gated wallet tracker reveal).
 */

export const WHALE_CONFIG = {
  // Phase durations (ms): dormant 3~8min, accum 60~120s, pump 30~60s, dump 20~40s
  dormantMin: 180_000,
  dormantMax: 480_000,
  accumMin: 60_000,
  accumMax: 120_000,
  pumpMin: 30_000,
  pumpMax: 60_000,
  dumpMin: 20_000,
  dumpMax: 40_000,

  /** only one coin may be pumping/dumping at a time; blocked whales retry after this */
  pumpHoldMin: 10_000,
  pumpHoldMax: 20_000,

  // Momentum bias in units of coin volatility per tick
  accumBias: 0.35,
  pumpBias: 2.8,
  dumpBias: 3.2,
  /** extra downward pull while price is still above the dump target */
  dumpExtraAboveTarget: 1.8,
  /** dump aims below accumulation start price (fraction of accumStartPrice) */
  dumpTargetRatio: 0.96,

  /** ad hook: wallet tracker reveals the live phase for this long (3 min per spec) */
  trackerRevealDuration: 180_000,
  /** ad hook: wallet tracker button cooldown per coin (90s per spec) */
  trackerCooldown: 90_000,
} as const;
